module.exports = __webpack_public_path__ + "static/quiz_stage_7_bg-0c68c02b5418313329ee442c1c6af7e3.svg";